import MapComponentNew from "./PropertyLocation";

const formatDistance = (km) => {
  const n = Number(km);
  if (!Number.isFinite(n)) return "";
  if (n <= 0) return "";
  return `${Number(n.toFixed(n >= 10 ? 0 : 1))} Km`;
};

const NearbyPlaces = ({ villaData }) => {
  const locationTitle =
    villaData?.listing_name ||
    villaData?.property_name ||
    villaData?.building ||
    "Property location";
  const locationSubtitle = [villaData?.building, villaData?.area, villaData?.name]
    .filter(Boolean)
    .filter((part, i, arr) => arr.indexOf(part) === i)
    .join(", ");

  const nearby = Array.isArray(villaData?.whats_nearby)
    ? villaData.whats_nearby.filter((item) => item?.name)
    : [];

  return (
    <div className="font-jt w-[95vw] lg:w-[90vw] mx-auto mb-8">
      <div className="text-[28px] lg:text-[40px] font-bold my-4 lg:mt-8 lg:mb-5 text-left">
        Getting There
      </div>
      <MapComponentNew
        longitude={villaData?.geo_long}
        latitude={villaData?.geo_lat}
        title={locationTitle}
        subtitle={locationSubtitle}
      />

      {nearby.length > 0 ? (
        <div className="mt-5">
          <div className="text-[18px] lg:text-[22px] font-semibold mb-3">
            Nearest point of interest
          </div>
          <div className="flex flex-wrap gap-x-6 gap-y-2 text-[14px] lg:text-[16px] text-[#444]">
            {nearby.slice(0, 8).map((item, i) => (
              <div key={item.id || `${item.name}-${i}`} className="flex items-center gap-2">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="#B0B0B0"
                  className="shrink-0"
                  aria-hidden="true"
                >
                  <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5A2.5 2.5 0 1 1 12 6.5a2.5 2.5 0 0 1 0 5z" />
                </svg>
                <span className="truncate max-w-[240px]">{item.name}</span>
                {formatDistance(item.distance_in_kms) ? (
                  <span className="text-[#717171] whitespace-nowrap">
                    , {formatDistance(item.distance_in_kms)}
                  </span>
                ) : null}
              </div>
            ))}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default NearbyPlaces;
